<template>
    <v-dialog v-model="show" hide-overlay fullscreen transition="dialog-bottom-transition">
        <div id="app" class="my-0 py-0">
            <v-app id="inspire">
                <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                    <v-card v-model="show" class="py-0">
                        <v-toolbar class="py-0 my-0" dark color="#d98880">
                            <v-toolbar-title class="my-0 py-0">Planilla de Inspección y Ensayo</v-toolbar-title>
                            <v-spacer></v-spacer>
                            EI 040
                            <v-spacer></v-spacer>
                            <v-btn icon dark @click="show = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                    </v-card>
                    <v-card color="#e6b0aa">
                        <v-card-text>
                            <h6 color="black"><b>Datos del Cliente </b></h6>
                            <v-row dense>
                                <v-col cols="6" sm="6" md="6">
                                    <h6> Razón Social: {{ codgral }} - {{ empresa }} </h6>
                                </v-col>
                                <v-col cols="6" sm="3" md="3">
                                    <h6> N° de Orden de Compra: {{ codoc }} </h6>
                                </v-col>
                                <v-col cols="6" sm="3" md="3">
                                    <h6> Fecha de Orden de Compra: {{ fecha }} </h6>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="12" md="12">
                                    <h6> Descripción: {{ provision }} </h6>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card color="#e6b0aa">
                        <v-card-text>
                            <h6 color="black"><b>Listado de Ensayos </b></h6>
                            <v-row dense>
                                <v-col cols="12" sm="6" md="6">
                                    <h6 color="black"><b>De Rutina</b></h6>
                                </v-col>
                                <v-col cols="12" sm="6" md="6">
                                    <h6 color="black"><b>Especiales</b></h6>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="6" md="3">
                                    <v-checkbox v-model="r1" label="Análisis de aceite por PCBs." color="success"
                                        value="ON" hide-details dense></v-checkbox>
                                    <v-checkbox v-model="r2" label="Constructivo." color="success" value="ON"
                                        hide-details dense></v-checkbox>
                                    <v-checkbox v-model="r3" label="Dimensional." color="success" value="ON"
                                        hide-details dense></v-checkbox>
                                    <v-checkbox v-model="r4" label="Discordancia de polos de interruptor."
                                        color="success" value="ON" hide-details dense></v-checkbox>
                                    <v-checkbox v-model="r5" label="Funcional eléctrico." color="success" value="ON"
                                        hide-details dense></v-checkbox>
                                    <v-checkbox v-model="r6" label="Funcional mecánico." color="success" value="ON"
                                        hide-details dense></v-checkbox>
                                    <v-checkbox v-model="r7" label="Hermeticidad." color="success" value="ON"
                                        hide-details dense></v-checkbox>
                                    <v-checkbox v-model="r8" label="Pintura." color="success" value="ON" hide-details
                                        dense></v-checkbox>
                                    <v-checkbox v-model="r9" label="Puesta a tierra." color="success" value="ON"
                                        hide-details dense></v-checkbox>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <v-checkbox v-model="r10" label="Relación de transformación." color="success"
                                        value="ON" hide-details dense></v-checkbox>
                                    <v-checkbox v-model="r11" label="Resistencia eléctrica de aislación."
                                        color="success" value="ON" hide-details dense></v-checkbox>
                                    <v-checkbox v-model="r12" label="Resistencia eléctrica de polos." color="success"
                                        value="ON" hide-details dense></v-checkbox>
                                    <v-checkbox v-model="r13" label="Resistividad de terreno." color="success"
                                        value="ON" hide-details dense></v-checkbox>
                                    <v-checkbox v-model="r14" label="Rigidez dieléctrica." color="success" value="ON"
                                        hide-details dense></v-checkbox>
                                    <v-checkbox v-model="r15" label="Rigidez dieléctrica de aceite." color="success"
                                        value="ON" hide-details dense></v-checkbox>
                                    <v-checkbox v-model="r16" label="Tiempos de apertura y cierre de interruptor."
                                        color="success" value="ON" hide-details dense></v-checkbox>
                                    <v-checkbox v-model="r17" label="Tiempos de disparo de interruptor." color="success"
                                        value="ON" hide-details dense></v-checkbox>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <v-checkbox v-model="e1" label="Arco interno." color="success" value="ON"
                                        hide-details dense></v-checkbox>
                                    <v-checkbox v-model="e2" label="Calentamiento." color="success" value="ON"
                                        hide-details dense></v-checkbox>
                                    <v-checkbox v-model="e3" label="Corriente resistida de breve duración."
                                        color="success" value="ON" hide-details dense></v-checkbox>
                                    <v-checkbox v-model="e4" label="Corriente resistida de cresta." color="success"
                                        value="ON" hide-details dense></v-checkbox>
                                    <v-checkbox v-model="e5" label="Cortocircuito." color="success" value="ON"
                                        hide-details dense></v-checkbox>
                                    <v-checkbox v-model="e6" label="Descargas parciales." color="success" value="ON"
                                        hide-details dense></v-checkbox>
                                    <v-checkbox v-model="e7" label="Factor de potencia." color="success" value="ON"
                                        hide-details dense></v-checkbox>
                                    <v-checkbox v-model="e8" label="Grado de protección mecánica (IP)." color="success"
                                        value="ON" hide-details dense></v-checkbox>
                                </v-col>
                                <v-col cols="12" sm="6" md="3">
                                    <v-checkbox v-model="e9" label="Impulso atmosférico." color="success" value="ON"
                                        hide-details dense></v-checkbox>
                                    <v-checkbox v-model="e10" label="Impacto." color="success" value="ON" hide-details
                                        dense></v-checkbox>
                                    <v-checkbox v-model="e11" label="Pérdidas en carga y tensión de impedancia."
                                        color="success" value="ON" hide-details dense></v-checkbox>
                                    <v-checkbox v-model="e12" label="Pérdidas en vacío y corriente de excitación."
                                        color="success" value="ON" hide-details dense></v-checkbox>
                                    <v-checkbox v-model="e13" label="Resistencia eléctrica de bobinados."
                                        color="success" value="ON" hide-details dense></v-checkbox>
                                    <v-checkbox v-model="e14" label="Sísmico." color="success" value="ON" hide-details
                                        dense></v-checkbox>
                                    <v-checkbox v-model="e15" label="Tensión inducida." color="success" value="ON"
                                        hide-details dense></v-checkbox>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="4" md="2">
                                    <v-text-field dense label="Protocolo de ensayo" v-model="protocolo1"
                                        outlined></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="4" md="2">
                                    <v-text-field dense label="Protocolo de ensayo" v-model="protocolo2"
                                        outlined></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="4" md="2">
                                    <v-text-field dense label="Protocolo de ensayo" v-model="protocolo3"
                                        outlined></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="4" md="2">
                                    <v-text-field dense label="Protocolo de ensayo" v-model="protocolo4"
                                        outlined></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="4" md="2">
                                    <v-text-field dense label="Protocolo de ensayo" v-model="protocolo5"
                                        outlined></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="4" md="2">
                                    <v-select color="red darken-3" dense v-model="estado" :items="estados"
                                        label="Estado" item-text="nombre" item-value="valor">
                                    </v-select>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card color="#d98880" dark tile>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="success" @click.stop="guardar" :disabled="deshabilitar">Guardar</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-app>
        </div>
    </v-dialog>
</template>
<style lang="scss">
.v-input--selection-controls {
    label {
        margin: 0 !important;
    }
}
</style>
<script>
import moment from "moment";
import axios from "../../axios-auth";
export default {
    data() {
        return {
            valid: false,
            lazy: false,
            empresa: "",
            provision: "",
            fecha: "",
            numot: "",
            r1: "",
            r2: "",
            r3: "",
            r4: "",
            r5: "",
            r6: "",
            r7: "",
            r8: "",
            r9: "",
            r10: "",
            r11: "",
            r12: "",
            r13: "",
            r14: "",
            r15: "",
            r16: "",
            r17: "",
            e1: "",
            e2: "",
            e3: "",
            e4: "",
            e5: "",
            e6: "",
            e7: "",
            e8: "",
            e9: "",
            e10: "",
            e11: "",
            e12: "",
            e13: "",
            e14: "",
            e15: "",
            protocolo1: "",
            protocolo2: "",
            protocolo3: "",
            protocolo4: "",
            protocolo5: "",
            estado: "",
            estados: [
                { nombre: 'Pendiente', valor: 'P' },
                { nombre: 'Para ensayar', valor: 'E' },
                { nombre: 'En ensayo', valor: 'I' },
                { nombre: 'Cerrado', valor: 'C' },
            ],
            deshabilitar: false,
        };
    },
    props: ["visible", "codgral", "codoc"],
    computed: {

        show: {
            get() {
                if (this.visible == true) {
                    this.responsable = this.$store.state.nombre.toString().trim();
                    //this.cargarListadoMail();
                    this.cargardatos();
                    // this.cargarrespcom();
                    // this.cargartipoproducto();
                    // this.cargarmodelo();
                    // this.cargarfuncion();
                }
                return this.visible;
            },
            set(value) {
                if (!value) {
                    //this.vaciarListado();
                    this.$refs.form.resetValidation();
                    document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
                    this.$emit("close");
                }
            },
        },
    },
    methods: {
        cargardatos() {
            const codgral = this.codgral;
            const codoc = this.codoc;
            let self = this;
            axios
                .get("/Lanzamiento/CargarCalidad?", {
                    params: {
                        codgral: codgral,
                        codoc: codoc,
                    },
                })
                .then((response) => {
                    self.empresa = response.data.empresa;
                    self.provision = response.data.provision;
                    self.fecha = response.data.fecha;
                    self.r1 = response.data.r1;
                    self.r2 = response.data.r2;
                    self.r3 = response.data.r3;
                    self.r4 = response.data.r4;
                    self.r5 = response.data.r5;
                    self.r6 = response.data.r6;
                    self.r7 = response.data.r7;
                    self.r8 = response.data.r8;
                    self.r9 = response.data.r9;
                    self.r10 = response.data.r10;
                    self.r11 = response.data.r11;
                    self.r12 = response.data.r12;
                    self.r13 = response.data.r13;
                    self.r14 = response.data.r14;
                    self.r15 = response.data.r15;
                    self.r16 = response.data.r16;
                    self.r17 = response.data.r17;
                    self.e1 = response.data.e1;
                    self.e2 = response.data.e2;
                    self.e3 = response.data.e3;
                    self.e4 = response.data.e4;
                    self.e5 = response.data.e5;
                    self.e6 = response.data.e6;
                    self.e7 = response.data.e7;
                    self.e8 = response.data.e8;
                    self.e9 = response.data.e9;
                    self.e10 = response.data.e10;
                    self.e11 = response.data.e11;
                    self.e12 = response.data.e12;
                    self.e13 = response.data.e13;
                    self.e14 = response.data.e14;
                    self.e15 = response.data.e15;
                    self.protocolo1 = response.data.protocolo1;
                    self.protocolo2 = response.data.protocolo2;
                    self.protocolo3 = response.data.protocolo3;
                    self.protocolo4 = response.data.protocolo4;
                    self.protocolo5 = response.data.protocolo5;
                    self.numot = response.data.numot;
                    self.estado = response.data.estado;

                })
                .catch((error) => {
                    //self.nomcodigo = [];
                    console.log(error);
                });
        },

        guardar() {
            this.deshabilitar = true;
            this.$swal({
                title: "Guardar Inspección y Ensayo",
                text: "¿Desea guardar los datos?",
                icon: "success",
                type: "success",
                showCancelButton: true,
                background: "#ececec",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    var datos = {
                        codoc: this.codoc,
                        codgral: this.codgral,
                        r1: this.r1,
                        r2: this.r2,
                        r3: this.r3,
                        r4: this.r4,
                        r5: this.r5,
                        r6: this.r6,
                        r7: this.r7,
                        r8: this.r8,
                        r9: this.r9,
                        r10: this.r10,
                        r11: this.r11,
                        r12: this.r12,
                        r13: this.r13,
                        r14: this.r14,
                        r15: this.r15,
                        r16: this.r16,
                        r17: this.r17,
                        e1: this.e1,
                        e2: this.e2,
                        e3: this.e3,
                        e4: this.e4,
                        e5: this.e5,
                        e6: this.e6,
                        e7: this.e7,
                        e8: this.e8,
                        e9: this.e9,
                        e10: this.e10,
                        e11: this.e11,
                        e12: this.e12,
                        e13: this.e13,
                        e14: this.e14,
                        e15: this.e15,
                        protocolo1: this.protocolo1,
                        protocolo2: this.protocolo2,
                        protocolo3: this.protocolo3,
                        protocolo4: this.protocolo4,
                        protocolo5: this.protocolo5,
                        estado: this.estado,

                    };

                    let self = this;
                    axios
                        .post("/Lanzamiento/GuardarCalidad", datos)
                        .then((response) => {
                            self.$refs.form.resetValidation();

                            self.showAlert({
                                icon: "success",
                                title: "Planilla guardada con éxito",
                                vm: self,
                            });
                            self.vaciarListado();
                            setTimeout(() => {
                                this.$router.push({ name: "LanzamientoMain" });
                            }, 5000);

                            self.$emit("close");
                        })
                        .catch({});
                }
            });
        },

        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 8000,
            });
        },

        vaciarListado() {
            this.empresa = "";
            this.fecha = "";
            this.numot = "";
            this.provision = "";
            this.r1 = "";
            this.r2 = "";
            this.r3 = "";
            this.r4 = "";
            this.r5 = "";
            this.r6 = "";
            this.r7 = "";
            this.r8 = "";
            this.r9 = "";
            this.r10 = "";
            this.r11 = "";
            this.r12 = "";
            this.r13 = "";
            this.r14 = "";
            this.r15 = "";
            this.r16 = "";
            this.r17 = "";
            this.e1 = "";
            this.e2 = "";
            this.e3 = "";
            this.e4 = "";
            this.e5 = "";
            this.e6 = "";
            this.e7 = "";
            this.e8 = "";
            this.e9 = "";
            this.e10 = "";
            this.e11 = "";
            this.e12 = "";
            this.e13 = "";
            this.e14 = "";
            this.e15 = "";
            this.protocolo1 = "";
            this.protocolo2 = "";
            this.protocolo3 = "";
            this.protocolo4 = "";
            this.protocolo5 = "";
            this.estado = "";
            this.deshabilitar = false;

        },
    },
};
</script>
